import React, { useState } from "react";
import QuranReader from "./ui/QuranReader";
import SearchQuran from "./ui/SearchQuran";
import { QuranChapters } from "../classes/QuranDataType";
import chapters from "../data/quran/chapters/en.json";
import { useNavigate } from "react-router-dom";

const Quran: React.FC = () => {
  const [selectedSurah, setSelectedSurah] = useState<QuranChapters | null>(
    chapters[0]
  );
  const navigate = useNavigate();

  const [showTranslation, setShowTranslation] = useState(true); // Toggle translations
  const [showTransliteration, setShowTransliteration] = useState(true); // Toggle translitrations

  const handleNextSurah = () => {
    if (selectedSurah && selectedSurah.id < 114) {
      const nextSurah = chapters.find(
        (surah) => surah.id === selectedSurah.id + 1
      );
      if (nextSurah) {
        setSelectedSurah(nextSurah);
        window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top smoothly
      }
    }
  };

  const handlePreviousSurah = () => {
    if (selectedSurah && selectedSurah.id > 1) {
      const prevSurah = chapters.find(
        (surah) => surah.id === selectedSurah.id - 1
      );
      if (prevSurah) {
        setSelectedSurah(prevSurah);
        window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top smoothly
      }
    }
  };

  return (
    <div className="mx-4 my-10 pb-12">
      <h1 className="font-grgrifter text-[2.8rem] tracking-wider text-[#AFAEB3] mb-10 w-full text-center">
        Al-Quran
      </h1>

      <button
        className="flex items-center justify-center px-3 py-2 rounded-[2em] cursor-pointer ml-2"
        type="submit"
        onClick={() => navigate("/home")}
      >
        {/* <ShowIcon size={18} className="mr-2" color="#3A9437" /> */}
        <p className="font-grgrifter text-sm tracking-widest text-left text-gray-500">
          {"< Back"}
        </p>
      </button>
      {/* <h1 className="text-2xl font-bold mb-4">📖 Quran App</h1> */}
      <SearchQuran
        onSelectSurah={(surah) => setSelectedSurah(surah)}
        showTranslation={showTranslation}
        setShowTranslation={setShowTranslation}
        showTransliteration={showTransliteration}
        setShowTransliteration={setShowTransliteration}
        selectedSurah={selectedSurah}
      />
      {selectedSurah !== null ? (
        <QuranReader
          selectedSurah={selectedSurah}
          showTranslation={showTranslation}
          showTransliteration={showTransliteration}
        />
      ) : (
        <p className="mt-4 text-gray-500 w-full text-center">
          Select a Surah to read.
        </p>
      )}

      {selectedSurah !== null ? (
        <div className="flex justify-center mt-4">
          <button
            className="px-4 py-2  text-[#3A9437] rounded-2xl mr-2 text-sm"
            onClick={handlePreviousSurah}
            disabled={!selectedSurah || selectedSurah.id === 1}
          >
            {"< Previous Surah"}
          </button>
          <button
            className="px-4 py-2  text-[#3A9437] rounded-2xl text-sm"
            onClick={handleNextSurah}
            disabled={!selectedSurah || selectedSurah.id === 114}
          >
            {"Next Surah >"}
          </button>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Quran;
